const translations = {
  // SEO
  siteTitle: "Shopee Thailand Data Challenge  2020",
  siteDesc:
    "Thailand Data Challenge 2020, proudly organised by Shopee is the largest data analytic competition in Thailand. The challenge is a one day data analytic competition open to all students and professionals .The competition consists of 2 rounds of Data Science and Data Analytics problems designed by Shopee Tech Teams. Participants must analyse the dataset, draw insightful conclusions and solve the problems in a specified amount of time. Not only will participants get a chance to code to generate insights that solve real industry problems, this competition will also provide them with an opportunity to test their coding skills and understand the importance of data analytic skills required in Shopee. It is free and open to tech and non-tech professionals working in Thailand as well as students currently enrolled in High School, polytechnics or universities in Thailand (including exchange students or other nationalities professionals). Register now as a group of 2 to 4 people and stand a chance to win over 100,000 baht in cash and Shopee coins prizes!  All winners of each category will be exclusively invited to visit Shopee Singapore’s office. Do not wait and hurry up to register and join the fun.",
  siteURL: "https://careers.shopee.co.th/thdatachallenge",
  siteImageURL:
    "https://careers.shopee.co.th/thdatachallenge/images/header_seo.png",
  seoStartdate: "2019-02-23T00:00+08:00",
  seoEnddate: "2019-03-30T23:59+08:00",
  seoPerformer: "Shopee Singapore",
  seolocationName: "NTU",
  seolocationAddress: "50 Nanyang Ave, Singapore 639798",
  seohasMap: "https://goo.gl/maps/3iTtkPVWDHS2",
  seoAudienceType: "EducationalAudience",
  // Nav
  navAbout: "About",
  navCategory: "Categories",
  navPrizes: "Prizes",
  navTimeline: "Timeline",
  navFaq: "FAQ",
  navPartners: "Partners",
  navContact: "Contact",
  navCareer: "Career",
  navCareerURL: "https://careers.shopee.sg/",
  //Hero
  dateRange: "23 Feb - 30 Mar 2019",
  heroDesc: "The largest data science competition in Indonesia",
  //Intro
  introduction: "Introduction",
  introDesc01:
    "Thailand Data Challenge 2020 aims to discover the most accurate and most efficient coder.",
  introDesc01p: "Through this competition, we aim to:",
  introLi01:
    "Equip students and professionals with essential data analytics skills and expertise to prepare them for the new digital economy",
  introLi02:
    "Bring the tech community closer through problem solving and knowledge sharing together",
  introLi03:
    "Provide participants with the opportunity to work on real dataset and challenges in the internet industry",
  introData: [
    {
      title: "Why should YOU join?",
      image: "about-01.png",
      desc:
        "Thailand Data Challenge 2020 is specially organised for tech enthusiasts like you to develop and grow your data analytics & coding abilities."
    },
    {
      title: "Who can join?",
      image: "about-02.png",
      desc:
        "We welcome students studying at a High School, polytechnic or universities in Thailand, as well as professionals from all fields.",
      desc02:
        "In the interest of fairness, employees of Sea Limited are not eligible to participate in the competition."
    },
    {
      title: "How to join?",
      image: "about-03.png",
      desc:
        "Join the fun for free! Register by forming a team of 2 - 4 members. Individual sign-ups are not allowed."
    },
    {
      title: "What else?",
      image: "about-04.png",
      desc:
        "Early-birds get to attend free training workshops specially organised by our partners. To sign up, do look out for the training workshop invites that will be sent to registered teams only!"
    }
  ],
  introAbout: "About the Challenge",
  introAboutDesc01:
    "Thailand Data Challenge 2020 is a one-day data analytics competition, open to all students and professionals.",
  introAboutDesc02:
    "The competition consists of 2 rounds of data analysis problems designed by Shopee tech teams. Participants must analyse the dataset, draw insightful conclusions and solve the problems in a specified amount of time.",
  introAboutDesc03:
    "Not only will participants get a chance to code to generate insights that solve real industry problems, this competition will also provide them with an opportunity to test their coding skills and understand the importance of data analytics skills required in Shopee.",
  //categories
  categories: "CATEGORIES",
  categoriesData: [
    {
      image: "images/theme-01.png",
      title: ["Pre-Tertiary"],
      list: [
        "For students in High School or polytechnics. International students on exchange are welcome."
      ]
    },
    {
      image: "images/theme-02.png",
      title: ["Undergraduates"],
      list: [
        "For students pursuing a Bachelor’s Degree. International students on exchange are welcome."
      ]
    },
    {
      image: "images/theme-03.png",
      title: ["Open"],
      list: [
        "For anyone in Thailand with an interest or passion for data analytics and able to utilize coding for solving problem statements."
      ]
    }
  ],
  //prize
  prizes: "Prizes",
  prizesTitle1: "For Pre-Tertiary category :",
  prizesData: [
    {
      name: "The Winner",
      image: "images/icon_reward.svg",
      price: "40,000 THB/team plus 20,000 Shopee Coins",
      list: [
        "Return ticket to visit Shopee HQ office in Singapore",
        "Full time / internship opportunities in Shopee"
      ]
    }
  ],
  prizesTitle2: "For Undergraduates & Open categories :",
  prizesData2: [
    {
      name: "The Winner",
      image: "images/icon_reward.svg",
      price: "70,000 THB/team plus 30,000 Shopee Coins",
      list: [
        "Return ticket to visit Shopee HQ office in Singapore",
        "Full time / internship opportunities in Shopee"
      ]
    },
    {
      name: "1st Runner-Up",
      image: "images/prize-01.png",
      price: "50,000 THB/team",
      list: ["Full time / internship opportunities in Shopee"]
    },
    {
      name: "2nd Runner-Up",
      image: "images/prize-02.png",
      price: "25,000 THB/team",
      list: ["Full time / internship opportunities in Shopee"]
    }
  ],
  // prizesDesc:
  //   "The Top 3 teams and the Most Creative Team from each category will win attractive cash prizes!",
  prizesNote:
    "All participants will receive a certificate of accomplishment at the end of the award ceremony only if their project has been submitted successfully before the deadline.",
  prizesNote02:
    "Please note that for the full-time/internship opportunities, actual placements are not guaranteed. It will be dependent on candidate’s fit during interviews.",
  // //Judge
  // judges: "Judges",
  // by: "by",
  // judgesDesc:
  //   "Our panel of prestigious judges will be selecting teams from each category with the most unique and creative solutions.",
  // judgesData: [
  //   {
  //     name: "Profesor Denny",
  //     image: "judge-denny.jpg",
  //     link: "http://www.ntu.edu.sg/home/boan/",
  //     title: "Director of Computer Science Center, Universitas Indonesia",
  //     desc:
  //       "Denny is the Director of Computer Science Center in Universitas Indonesia who received his Ph.D. in data science from The Australian National University in 2013. With his first research being published in Advances in Knowledge Discovery and Data Mining, he has now published more than 10 research ranging from Data Mining, Database Systems, and Computational Intelligence. He teaches advanced algorithms, data structures and Big Data courses."
  //   },
  //   {
  //     name: "Associate Professor Imas Sukaesih Sitanggang",
  //     image: "judge-imas.jpg",
  //     link: "",
  //     title: "Lecturer in Computer Science department, IPB University",
  //     desc:
  //       "Imas Sitanggang is the Lecturer in Computer Science department at Bogor Agricultural University. She has a keen interest in data mining, spatial data processing, and their applications to forest and land fire risk modeling. She was trusted with various research grants from different institutions as well as devoted to numerous fellowship programs in her field."
  //   },
  //   {
  //     name: "Ivan Wangsa",
  //     image: "judge-ivan.jpg",
  //     link: "",
  //     title: "Head of Business Intelligence, Shopee",
  //     desc:
  //       "Ivan Wangsa adalah Head of Business Intelligence di Shopee Indonesia, memimpin tim yang terdiri lebih dari 50 Data Analis dan Engineers dan memiliki fokus yang kuat pada data.  Setelah mendapatkan gelar sarjana Matematika dari National Technological University di Singapura, beliau memulai karirnya di Sea group (perusahaan Shopee) di tahun 2015, dengan pengalaman dari berbagai lini bisnis Sea (Corporate, Garena, Shopee, AirPay)."
  //   },
  //   {
  //     name: "Dr. Alexander Gunawan",
  //     image: "judge-alexander.jpg",
  //     link: "",
  //     title:
  //       "Ketua Jurusan, Teknik Informatika-Matematika dan Teknik Informatika-Statistika, Universitas Bina Nusantara",
  //     desc:
  //       "Dr. Alexander Gunawan adalah seorang Ilmuwan Komputer dan Ahli Matematika. Beliau memiliki minat untuk Artificial Intelligence dan mahir dalam Deep Learning dan kerangka Bayesian. Dalam disertasinya, beliau mengeksploitasi kerangka Bayesian untuk mengembangkan algoritma yang cepat dan optimal dalam Visual Object Tracking. Beliau juga memiliki wawasan dalam Industri Robotika dan Autonomous Mobile Robots, serta Natural Language Processing yang telah menuntunnya dalam beberapa riset mengenai subjek tersebut. Beliau juga rutin membuat ulasan untuk jurnal internasional."
  //   }
  // ],
  //Timeline
  timeline: "Timeline",
  timelineData: [
    {
      date: "25 Jan 2020",
      desc: "Registration Opens"
    },
    {
      date: "8 Mar 2020",
      desc: "Registration Closes"
    },
    {
      date: ["17 Feb 2020", "to 14 Mar 2020"],
      desc: "Series of Training & Workshops"
    },
    {
      date: "Tentative Date",
      desc: "Challenge Day"
    }
  ],
  //training workshop
  trainingWorkshops: "Training & Workshops",
  trainingDesc:
    "Register for the competition and you will receive updates on upcoming training workshops. Please note that only successfully registered teams will receive invitations for the training workshops.",
  trainingDesc2:
    "Sign up for the challenge to receive more details on our training workshops!",
  trainingData: [
    {
      date: "26 Jan 2019",
      name: "Advanced Training",
      organizer: "YiDu AI",
      state: "Registration is closed",
      list: [
        "Overview of Tensorflow",
        "Elements of Tensorflow",
        "Visualization of Computational Graph",
        "Train your model with Tensorflow",
        "Your first neural Network with Tensorflow",
        "Advanced topics in Tensorflow"
      ]
    },
    {
      date: "2 Feb 2019",
      name: "Beginners Training",
      organizer: "YiDu AI",
      state: "Registration is closed",
      list: [
        "Introduction to Python",
        "Introduction to Data Science and Machine Learning",
        "Linear Regression",
        "Logistics Regression",
        "Decision Tree",
        "AEnsemble Learning",
        "Support Vector Machine",
        "Hands-on Project"
      ]
    },
    {
      date: "9 Jan - 30 Jan 2019",
      name: "Beginners Training",
      organizer: "UpCode Academy",
      state: "Registration is closed",
      list: [
        "Intro to Deep Learning",
        "CNN Introduction",
        "Improving CNNs",
        "How a CNN learns"
      ]
    },
    {
      date: "12 Jan - 13 Feb 2019",
      name: "Advanced Training",
      organizer: "UpCode Academy",
      state: "Registration is closed",
      list: ["Overfitting", "CNN + RNN", "CNNs Top Architectures", "NLP"]
    }
  ],
  // Register
  register: "Registration",
  registerNow: "Register Now",
  registerDuration: [
    "Registration opens on ",
    "25 January 2020",
    " and closes on ",
    "8 March 2020"
  ],
  registerNowDesc:
    "Ready to put your data analytics skills to the test? Register now!",
  registerClose: "Registration for Thailand Data Challenge  is closed.",
  //partner
  partners: "Partners",
  organized: "Proudly Organized by Shopee",
  organizedData: [
    {
      name: "Shopee Thailand",
      image: "shopee_logo_en.png",
      link: "https://careers.shopee.co.th/"
    }
  ],
  govPartner: "Government Partners",
  govPartnerData: [
    {
      name: "Ministry of Digital Economy and Society",
      image: "Ministry_of_Digital_Economy_and_Society_of_Thailand.png",
      link: "https://www.mdes.go.th/"
    },
    {
      name: "Thailand Digital Economy Promotion Agency",
      image: "DEPA.jpg",
      link: "https://www.depa.or.th/th/home"
    },
    {
      name: "National Innovation Agency (NIA)",
      image: "nia_logo.jpg",
      link: "https://www.nia.or.th/"
    }
  ],
  mediaPartner: "Media Partners",
  mediaPartnerData: [
    {
      name: "Beartai",
      image: "logo_beartai.png",
      link: "https://www.beartai.com/"
    }
  ],
  trainingPartners: "Training Partners",
  trainingPartnersData: [
    {
      name: "Career Visa",
      image: "logo_careervisa.png",
      link: "https://web.careervisathailand.com/"
    },
    {
      name: "BotNoi",
      image: "botnoi_logo.png",
      link: "http://www.botnoigroup.com/"
    },
    {
      name: "Data Cafe’",
      image: "Data-Cafe-logo.png",
      link: "http://www.datacafethailand.com/"
    },
    {
      name: "EdWINGS Education",
      image: "EdWings.png",
      link: "http://edwings.co/"
    },
    {
      name: "Here Technologies",
      image: "HERE_Logo_2016_POS_cmyk_IsoCV2.png",
      link: "https://www.here.com/"
    },
    {
      name: "Microsoft Thailand",
      image: "MSFT_logo.png",
      link: "https://www.microsoft.com/th-th"
    },
    {
      name: "Skooldio",
      image: "skooldio-logo.png",
      link: "https://www.skooldio.com/"
    },
    {
      name: "Software Park Thailand",
      image: "softwarepark.png",
      link: "http://www.swpark.or.th/"
    },
    {
      name: "Chulalongkorn University Technology Center",
      image: "utc_logo.jpg",
      link: "https://www.research.chula.ac.th/"
    },
    {
      name: "ZYMPLE",
      image: "ZYMPLE-logo.png",
      link: "https://zymple.biz/"
    }
  ],
  universityPartners: "University & Academic Partners",
  universityPartnersData: [
    {
      name: "Assumption University",
      image: "Assumption University.png",
      link: "http://www.au.edu/"
    },
    {
      name: "Bangkok University",
      image: "Bangkok University.png",
      link: "https://www.facebook.com/BU.International/"
    },
    {
      name: "Chulalongkorn Business School",
      image: "CBS.jpg",
      link: "https://www.cbs.chula.ac.th/en/"
    },
    {
      name: "Faculty of Engineering, Chulalongkorn University",
      image: "Chulalongkorn University_Computer Engineering.png",
      link: "https://www.eng.chula.ac.th/en/"
    },
    {
      name: "Faculty of Science, Chulalongkorn University",
      image: "CU SCI.png",
      link: "http://web.sc.chula.ac.th/index.php"
    },
    {
      name:
        "Department of mathematics and computer science Faculty of science, Chulalongkorn university",
      image: "math.sc.chula.logo.png",
      link: "https://math.sc.chula.ac.th/"
    },
    {
      name: "Kaplan",
      image: "Kaplan.png",
      link: "https://www.kaplaninternational.com/"
    },
    {
      name: "Star E.D.U.",
      image: "Kaplan_cep.jpg",
      link: "http://www.kapstar.com/"
    },
    {
      name: "Faculty of Economics, Khon Kaen University",
      image: "Econ KKU.png",
      link: "https://econ.kku.ac.th/app/webroot/cro/"
    },
    {
      name: "King Mongkut's Institute of Technology Ladkrabang",
      image: "kmitl_logo.png",
      link: "https://www.kmitl.ac.th/en"
    },
    {
      name:
        "The Computer Innovation Engineering Program, King Mongkut's Institute of Technology Ladkrabang",
      image: "kmitl_cie_logo.jpg",
      link: "https://cie.kmitl.ac.th/"
    },
    {
      name:
        "Faculty of Information Technology, King Mongkut's Institute of Technology Ladkrabang",
      image: "IT KMITL_LOGO.jpg",
      link: "https://www.it.kmitl.ac.th/en/"
    },
    {
      name: "Mahanakorn University of Technology",
      image: "MUT_Backup.png",
      link: "http://www.mut.ac.th/"
    },
    {
      name: "Mahasarakham Business School",
      image: "Mahasarakarn-University-_Accounting.png",
      link: "http://www.mbs.msu.ac.th/"
    },
    {
      name: "Mahasarakham University",
      image: "MSU Logo.jpg",
      link: "http://www.msu.ac.th/exslides.php"
    },
    {
      name: "Mahidol University International College",
      image: "Mahidol.png",
      link: "https://muic.mahidol.ac.th/eng/"
    },
    {
      name: "Naresuan University",
      image: "NULOGO-Download-EN.png",
      link: "https://www.nu.ac.th/?page_id=15142&lang=en"
    },
    {
      name: "Faculty of Management and Information Science Naresuan University",
      image: "BEC NU.jpg",
      link: "http://www.bec.nu.ac.th/cutwebb/"
    },
    {
      name: "Srinakharinwirot University",
      image: "Srinakharinwirot_Logo_EN_Color.jpg",
      link: "https://www.swu.ac.th/en/"
    },
    {
      name: "Faculty of Economics, Srinakharinwirot University",
      image: "swu-logo.png",
      link: "http://econ.swu.ac.th/"
    },
    {
      name: "Sirindhorn International Institute of Technology",
      image: "SIIT.jpg",
      link: "https://www.siit.tu.ac.th/"
    },
    {
      name: "BBA International Program, Thammasat Business School",
      image: "ThammasatBusinessSchool.png",
      link: "http://www.bba.tbs.tu.ac.th/"
    },
    {
      name: "Thammasat University",
      image: "TU.png",
      link: "https://tu.ac.th/en"
    }
  ],
  techPartners: "Tech Communities Partners",
  techPartnersData: [
    {
      name: "Codesanook",
      image: "AW_LOGO_codesanook_ALL.png",
      link: "https://www.facebook.com/codesanookpage/"
    },
    {
      name: "CUPy",
      image: "cupy_logo.png",
      link: "https://www.facebook.com/cupy2019/"
    },
    {
      name: "Data Cube",
      image: "DataCube.png",
      link: "https://www.facebook.com/datacube.th/"
    },
    {
      name: "Data Science Thailand",
      image: "DataScienceLab.jpg",
      link: "https://www.facebook.com/DataScienceTh/"
    },
    {
      name: "Thai Programmer",
      image: "Thai Programmer.png",
      link: "https://www.thaiprogrammer.org/"
    },
    {
      name: "Software Engineering Thailand",
      image: "amdis_logo_final_.png",
      link: "http://www.amdis-services.com/"
    },
    {
      name: "Facebook Developer Circle (DevC) Bangkok",
      image: "dev_c.jpg",
      link: "https://www.facebook.com/groups/DevCBangkok/"
    },
    {
      name: "Katinrun",
      image: "katinrun-logo.png",
      link: "https://www.facebook.com/Katinrun/"
    },
    {
      name: "KULAP",
      image: "kulap_logo.png",
      link: "https://www.kulap.io/"
    }
  ],
  diversityPartners: "Partners in diversities",
  diversityPartnersData: [
    {
      name: "Girls Who Dev",
      image: "GWD_2017LOGO.png",
      link: "https://www.facebook.com/girlswhodev/"
    },
    {
      name: "PyLadies Bangkok",
      image: "pyladiesbkkfin.png",
      link: "https://www.facebook.com/pyladiesbkk/"
    },
    {
      name: "Women Who Code Bangkok",
      image: "WWCode_Logo.png",
      link: "https://www.womenwhocode.com/"
    }
  ],
  supportPartners: "Supporting Partners",
  supportPartnersData: [
    {
      name: "OnDemand",
      image: "ondemand.png",
      link: "https://www.ondemand.in.th/"
    },
    {
      name: "Singha Estate",
      image: "Singha Estate.png",
      link: "https://www.singhaestate.co.th/en#intro"
    }
    // {
    //   name: "SAMSUNG Thailand",
    //   image: "Samsung.png",
    //   link: "https://www.samsung.com/th/"
    // }
  ],
  //faq
  faq: "Frequently Asked Questions",
  faqData: [
    {
      title: "About the Challenge",
      items: [
        {
          question: "Am I required to code in Python?",
          answer: "No, you can use any other programming languages"
        },
        {
          question:
            "I have no/little knowledge about coding. Can I still participate?",
          answer:
            "Yes you can! We have training workshops specially organised by our partners. Do keep a lookout for these training workshop invites that will be sent to registered teams."
        },
        {
          question:
            "Is it necessary for the whole team to stay throughout the competition?",
          answer:
            "Yes, the entire team has to be physically present throughout the competition."
        },
        {
          question: "What do I have to bring to the competition?",
          answer:
            "Please bring along your own set of laptop, charger and adaptor as no equipment will be provided. Each team member is restricted to one set of laptop, charger and adaptor."
        },
        {
          question:
            "Will I receive a certificate at the end of the competition, even if I did not win the top 3 prizes?",
          answer: "Yes"
        }
      ]
    },
    {
      title: "Eligibility",
      items: [
        {
          question:
            "I am not based in Thailand during the course of the competition, can I still participate in the challenge?",
          answer:
            "The challenge is currently only open to participants who are based in Thailand."
        },
        {
          question: "What is the age limit?",
          answer:
            "You need to be at least 16 years old in order to participate. If you are below 16 but you are keen to join this competition, please write in to us at datachallengeth@shopee.com  and we will review it on a case-by-case basis."
        }
      ]
    },
    {
      title: "Registration",
      items: [
        {
          question:
            "How do I know if my registration for Thailand Data Challenge is successful?",
          answer:
            "A confirmation email will be sent to you within 1-2 weeks after you submit the form. If you did not receive it, please write in to us at datachallengeth@shopee.com to check your registration status. Also, please confirm your registration before <strong>9 March 2020, 23.59h</strong>."
        },
        {
          question: "Can I sign up as an individual?",
          answer: "We will not accept any individual sign-ups."
        },
        {
          question:
            "Will every team member have to submit the registration form once?",
          answer:
            "You only need to submit one form as a team as each form will require all members to fill in their details."
        },
        {
          question:
            "My team consists of both students/non-tech professionals and tech professionals. Which category should we sign up for?",
          answer:
            "You must sign up for the higher category if there is a mixture of qualifications in your team. In this case, you need to sign up for the Open category since there are professionals in your team."
        },
        {
          question: "Can my team participate in two different categories?",
          answer: "No, you can only participate in 1 category."
        },
        {
          question:
            "When filling in the registration form, I keyed in my details incorrectly. How do I make changes to it after the submission?",
          answer: `Please write in to datachallengeth@shopee.com with the following details: <br/>1. Your name<br/>2. Team name<br/>3. The details you entered<br/>4. The correct details <br/>We will make the necessary changes on our side.
        `
        },
        {
          question:
            "My team would like to add or change or remove a member. How do we do so?",
          answer: `Please write in to datachallengeth@shopee.com with the following details: <br/>1. Your name<br/>2. Team name<br/>3. New member’s details following the registration form (i.e. name, occupation etc.)      
        `
        }
      ]
    },
    {
      title: "Training Workshops",
      items: [
        {
          question: "Can I participate in every training workshop?",
          answer: `This is an early sign-up training. However,as slots are limited, priority will be given to participants from the respective categories. Do check with us and we will open the seat for you if there are vacancies.<br/><br/>Please email datachallengeth@shopee.com to check for vacancies nearer to the dates of the training workshop.
          `
        }
      ]
    }
  ],
  faqTitle02: "Eligibility",
  faqData02: [
    {
      question:
        "I am not based in Thailand during the course of the competition, can I still participate in the challenge?",
      answer:
        "The challenge is currently only open to participants who are based in Thailand."
    },
    {
      question: "What is the age limit?",
      answer:
        "You need to be at least 16 years old in order to participate. If you are below 16 but you are keen to join this competition, please write in to us at datachallengeth@shopee.com  and we will review it on a case-by-case basis."
    }
  ],
  faqTitle03: "Registration",
  faqData03: [
    {
      question:
        "How do I know if my registration for Thailand Data Challenge is successful?",
      answer:
        "A confirmation email will be sent to you within 1-2 weeks after you submit the form. If you did not receive it, please write in to us at datachallengeth@shopee.com to check your registration status. Also, please confirm your registration before <strong>9 March 2020, 23.59h</strong>."
    },
    {
      question: "Can I sign up as an individual?",
      answer: "We will not accept any individual sign-ups."
    },
    {
      question:
        "Will every team member have to submit the registration form once?",
      answer:
        "You only need to submit one form as a team as each form will require all members to fill in their details."
    },
    {
      question:
        "My team consists of both students/non-tech professionals and tech professionals. Which category should we sign up for?",
      answer:
        "You must sign up for the higher category if there is a mixture of qualifications in your team. In this case, you need to sign up for the Open category since there are professionals in your team."
    },
    {
      question: "Can my team participate in two different categories?",
      answer: "No, you can only participate in 1 category."
    },
    {
      question:
        "When filling in the registration form, I keyed in my details incorrectly. How do I make changes to it after the submission?",
      answer: `Please write in to datachallengeth@shopee.com with the following details: 
      <br/>
      1. Your name
      <br/>
      2. Team name
      <br/>
      3. The details you entered
      <br/>
      4. The correct details 
      <br/>
      We will make the necessary changes on our side.
      `
    },
    {
      question:
        "My team would like to add or change or remove a member. How do we do so?",
      answer: `Please write in to datachallengeth@shopee.com with the following details: 
      <br/>
      1. Your name
      <br/>
      2. Team name
      <br/>
      3. New member’s details following the registration form (i.e. name, occupation etc.)      
      `
    }
  ],
  faqTitle04: "Training Workshops",
  faqData04: [
    {
      question: "Can I participate in every training workshop?",
      answer: `This is an early sign-up training. However,as slots are limited, priority will be given to participants from the respective categories. Do check with us and we will open the seat for you if there are vacancies.
        <br/>
        Please email datachallengeth@shopee.com to check for vacancies nearer to the dates of the training workshop.
        `
    }
  ],
  //contact
  contactDesc01: "Do you have any questions about Thailand Data Challenge?",
  contactBtn: "Contact Us",
  contactDesc02:
    "For partnership opportunities on tech-related events, please email to:",
  contactEmail: "datachallengeth@shopee.com",
  //footer
  instagram: "Instagram",
  instagramLink: "https://www.instagram.com/LifeatShopee",
  linkedin: "LinkedIn",
  linkedinLink: "https://linkedin.com/company/Shopee",
  career: "Career",
  careerLink: "https://careers.shopee.sg/",
  copyright: "2018-2019 Shopee All rights reserved.",
  termAndCond: "Terms and Conditions",
  privacy: "Privacy Policy"
};

export default translations;
